import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'lib/utility/i18n';
import { getFileNameFromUrl } from '../playlists/helpers';

const MediaPreview = ({ url, showFileName }) => (
  <div className={url ? "media-chooser__image-preview" : "hide"}>
    <span className="media-chooser__image-preview-label">{i18n.t('Preview')}: {url && showFileName && getFileNameFromUrl(url)} </span><br />
    {url ?
      <img src={url} width={200} className="media_chooser__image" />
      :
      <em>No Image</em>
    }
  </div>
);

MediaPreview.propTypes = {
  url: PropTypes.string,
  showFileName: PropTypes.bool
};

export default MediaPreview;
